import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import { devConfig } from 'config/config'; // Import development configuration
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component

/**
 * Represents the area view in the application.
 * @extends JetView
 */
export default class areaView extends JetView {
    /**
     * Configures the UI components for the area view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            id: 'a10', // Unique identifier for the form
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    type: 'wide', // Wide type for layout
                    responsive: 'a10', // Responsive layout identifier
                    margin: 10, // Margin around the layout
                    cols: [
                        {
                            localId: 'inner:layout', // Local identifier for the inner layout
                            gravity: 4, // Gravity for layout distribution
                            type: 'wide', // Wide type for inner layout
                            rows: [
                                {
                                    view: 'tabbar', // Tab bar component
                                    localId: 'tabbar', // Local identifier for the tab bar
                                    height: 35, // Height of the tab bar
                                    options: [
                                        // Tab options
                                        {
                                            id: 'accounting.area_copy', // Identifier for the first tab
                                            value: _('Areas'), // Translated label for the first tab
                                        },
                                        {
                                            id: 'accounting.position', // Identifier for the second tab
                                            value: _('Cargo'), // Translated label for the second tab
                                        },
                                        {
                                            id: 'accounting.typeCenterPosition', // Identifier for the third tab
                                            value: _('Tipo'), // Translated label for the third tab
                                        },
                                        {
                                            id: 'accounting.employees', // Identifier for the fourth tab
                                            value: _('Empleados'), // Translated label for the fourth tab
                                        },
                                    ],
                                },
                                { $subview: true }, // Placeholder for subview
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the area view.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use the Menu plugin with the tab bar
    }
}

// FILE DOCUMENTED
